import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { CallingComponent } from './calling/calling.component';
import { ProgressiveDialerComponent } from './dialer/dialer.component';
import { OzonetelIframeComponent } from '../ozonetel-iframe/ozonetel-iframe.component';
import { CubeIframeComponent } from '../cube-iframe/cube-iframe.component';
import { CallingService } from './calling.service';
import { OzonetelTransferService } from './ozonetel/ozonetel-transfer.service';
import { OzonetelWrapUpService } from './ozonetel/ozonetel-wrap-up.service';
import { CubeWrapUpService } from './cube/cube-wrap-up.service';
import { CentroWrapUpService } from './centro/centro-wrap-up.service';
import { AngularMaterialModule } from 'src/app/_Common/_Modules/angular.material.module';
import { SharedModule } from 'src/app/_Common/_Components/shared.module';
import { IgnosisTransferComponent } from './ignosis/ignosis-transfer.component';

@NgModule({
  imports: [AngularMaterialModule, SharedModule, FormsModule, ReactiveFormsModule, RouterModule],
  exports: [CallingComponent, ProgressiveDialerComponent, OzonetelIframeComponent, CubeIframeComponent, IgnosisTransferComponent],
  declarations: [CallingComponent, ProgressiveDialerComponent, OzonetelIframeComponent, CubeIframeComponent, IgnosisTransferComponent],
  providers: [
    CallingService,
    OzonetelTransferService,
    OzonetelWrapUpService,
    CubeWrapUpService,
    CentroWrapUpService,
  ]
})
export class CallingModule {}
